import React from 'react';
import './App.css';
import WebPage from './Main.js';

function App() {
  return (
    <div className="App">
      <WebPage />
    </div>
  );
}

export default App;
